var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFabricationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 58
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Fabrication Icon",
  transform: "translate(-4.726 -6)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 2",
  cx: 29,
  cy: 29,
  r: 29,
  transform: "translate(4.726 6)",
  fill: "#f3f3f3"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4e4e4e",
  stroke: "#4e4e4e"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 69",
  d: "M19.595 24.293h28.262v8.432H27.069v15.941h-7.474Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 70",
  d: "M31.956 35.944h7.825v7.538h-8.2v-8.039"
})))));
export default SvgFabricationIcon;